<template lang="pug">
  div
    p.text-center Conversación en bandeja
    b-form-select.mb-3(v-model="box", :options="boxes", @change="changed")
      template(slot="first")
        option(:value="null", disabled) -- Seleccionar bandeja --
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import boxes from '../data/boxes'

export default {
  data () {
    return {
      filters_open: false,
      boxes: boxes,
      box: null
    }
  },
  methods: {
    ...mapActions(['conversation/get', 'conversation/update']),
    getConversation () {
      let self = this

      this['conversation/get']({
        conversation_id: self.$route.params.conversation_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.box = res.resource.box
          }
        }
      })
    },
    updateConversation () {
      let self = this

      this['conversation/update']({
        conversation_id: self.$route.params.conversation_id,
        box: self.box,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Conversación actualizada')
          }
        }
      })
    },
    changed () {
      this.updateConversation()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getConversation()
    })
  }
}
</script>

<style lang="scss" scoped>
  .scrollable-container-sm {
    max-height: 200px;
    overflow: hidden;
    overflow-y: auto;
    word-break: break-all;
  }

  .collapse-icon {
    transition: 0.3s;
  }

  .upsidedown {
    transform: rotate(-180deg);
  }
</style>
